import React from 'react';
import Bugsnag from '@bugsnag/js';
import Layout from '@99designs/apps/spa/common/Layout/Layout';
import { Site } from '@99designs/frontend-components/apps/global-nav/lib/Site';
import { FullscreenError } from '@99designs/layout';

interface State {
    error?: Error;
}

interface Props {
    site: Site;
}

class ErrorBoundary extends React.Component<Props, State> {
    state: State = {};

    componentDidCatch(error: Error) {
        this.setState({ error });
    }

    render() {
        const { error } = this.state;

        if (error) {
            Bugsnag.notify(error);

            return (
                // eslint-disable-next-line jsx-a11y/aria-role
                <Layout role="logged-out" site={this.props.site}>
                    <FullscreenError error={error} errorCode="500" />
                </Layout>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
